<template>
  <div class="form-input">
    <label class="label-input">{{ label }}</label>
    <textarea
      class="input"
      @input="changeInput"
      :value="value"
      autocomplete="off"
    />
    <p :class="[hasError ? 'error' : 'no-error']">
      {{ error.esMessage }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { MessageError } from "@/business/shared/commons/validator/validatorsTypes";

export default defineComponent({
  name: "GeneralTextArea",
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: Object as () => MessageError,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  setup(props, context) {
    function changeInput(event: any) {
      context.emit("update:text", event.target.value);
    }

    return { changeInput };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/generalTextAreaStyle";
</style>
